import React from 'react';
import { Drawer } from 'antd';
import css from './css.module.less';

const _Drawer = (props) => {
  const {
    children,
    visible,
    onClose,
    title,
    placement,
    noContainerStyle,
    className,
    closable,
    ...rest
  } = props;

  const _onClose = () => {
    if (onClose) onClose();
  };

  return (
    <>
      <Drawer
        title={title}
        placement={placement || 'right'}
        closable={closable || true}
        onClose={_onClose}
        className={`${noContainerStyle ? css.containerNoStyle : ''} ${
          className || ''
        }`}
        maskClosable={false}
        visible={visible}
        {...rest}>
        {children}
      </Drawer>
    </>
  );
};
export default _Drawer;
